import React from 'react'
import { dangericon, error1 } from '../../imagepath';
import { Link } from 'react-router-dom';

const Error = () => {
  return (
    <>
      <div className="main-wrapper error-wrapper">
  <div className="error-box">
    <img className="img-fluid" src={error1} alt="Logo" />
    <h3>
      <img
        className="img-fluid mb-0"
        src={dangericon}
        alt="Logo"
      />{" "}
      Página no encontrada
    </h3>
    <p>Es posible que hayas escrito mal la dirección o que la página se haya movido.</p>
    <Link to="/" className="btn btn-primary go-home">
      Ir al inicio
    </Link>
  </div>
</div>

    </>
  )
}

export default Error;
